import { distanceKmFromKitchen } from './cartDistanceUtils';

/**
 * Match checkout form to a saved address for distance-based checkCart.
 * @param {Array<{ address: string, city: string, postalCode: string, latitude: number | null, longitude: number | null }>} addresses
 * @param {{ address1?: string, city?: string, pincode?: string }} form
 */
export function findSavedAddressForCheckoutForm(addresses, form) {
  const line = String(form.address1 || '').trim().toLowerCase();
  const city = String(form.city || '').trim().toLowerCase();
  const pin = String(form.pincode || '').trim();
  if (!line || !city || !/^\d{6}$/.test(pin)) return null;

  return (
    addresses.find((a) => {
      const addr = String(a.address || '').trim().toLowerCase();
      const aCity = String(a.city || '').trim().toLowerCase();
      const aPin = String(a.postalCode || '').trim();
      return (
        aPin === pin &&
        aCity === city &&
        (addr === line || addr.includes(line) || line.includes(addr))
      );
    }) ?? null
  );
}

/**
 * @param {string} fulfillmentType
 * @param {boolean} addressConfirmed
 * @param {number | null | undefined} distanceKmFromSaved
 */
export function resolveCheckoutDistanceKm(
  fulfillmentType,
  addressConfirmed,
  distanceKmFromSaved,
) {
  if (fulfillmentType === 'pickup') return 0;
  if (!addressConfirmed) return null;
  if (distanceKmFromSaved != null && Number.isFinite(distanceKmFromSaved)) {
    return distanceKmFromSaved;
  }
  return null;
}

export { distanceKmFromKitchen };
